export const formatCategory = (category: string) =>
  category.replace('category', '')
